import { mapGetters } from 'vuex'

export const InvoiceSubIdMixin = {
  data () {
    return {
      isimId: null
    }
  },
  computed: {
    ...mapGetters(['SUB_INVOICE_SERIES', 'SUB_INVOICE_SERIE_FOR_ID'])
  },
  async mounted () {
    await this.$store.dispatch('GET_SUB_INVOICE_SERIES')
  },
  methods: {
    isimGenerateId (id) {
      if (id === 0) {
        return '000'
      }

      const serie = this.SUB_INVOICE_SERIE_FOR_ID(id)
      const actualId = id - serie.reset
      return serie.prefix + String(actualId).padStart(3, '0')
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/InvoiceSubIdMixin.js